<template>
  <component
    :is="isComponent"
    :invoiceData="invoiceData"
    :invoiceState="invoiceState"
    :invoiceTypes="invoiceTypes"
  ></component>
</template>
<script>
import InvoiceCar from './components/InvoiceCar/index.vue';
import Invoice from './components/invoice/index.vue';
import InvoiceCarSecond from './components/invoiceCarSecond/index.vue';
import InvoiceRoll from './components/InvoiceRoll/index.vue';
import InvoiceToll from './components/InvoiceToll/index.vue';

export default {
  name: 'InvoiceCode',
  props: ['invoiceData'],
  data() {
    return {
      isComponent: 'Invoice', // 组件名称
      invoiceState: '', // 判断发票状态是0-正常1-失控invoiceOutcontrol 2-作废invoiceDelete 3-红冲invoiceRed 4-异常invoiceAbnormal
      invoiceTypes: '', // 发票类型 上面的文字
      invoiceTit: '', // 默认title名称
    };
  },
  created() {

  },
  mounted() {
    this.isComponent = this.judgeInvoiceType(this.invoiceData.invoiceTypeCode);
    const typeData = this.invoiceTypeFc(this.invoiceData.invoiceTypeCode);
    this.invoiceTypes = typeData.type || '';
    this.invoiceTit = typeData.title || '';
    console.log('invoiceTypes========', this.invoiceTypes);
    this.invoiceState = this.invoiceStateFc(this.invoiceData.state);
  },
  components: {
    InvoiceCar,
    Invoice,
    InvoiceCarSecond,
    InvoiceRoll,
    InvoiceToll,
  },
  methods: {
    judgeInvoiceType(invoiceTypeCode) {
      console.log('invoiceTypeCode===', invoiceTypeCode);
      if (!invoiceTypeCode) {
        return 'Invoice';
      }
      if (invoiceTypeCode === '004' || invoiceTypeCode === '007' || invoiceTypeCode === '026') {
        return 'Invoice';
      } if (invoiceTypeCode === '025') {
        return 'InvoiceRoll';
      } if (invoiceTypeCode === '005') {
        return 'InvoiceCar';
      } if (invoiceTypeCode === '14') {
        return 'InvoiceToll';
      } if (invoiceTypeCode === '006') {
        return 'InvoiceCarSecond';
      }
      return 'Invoice';
    },
    invoiceStateFc(state) {
      switch (state) {
        case '0':
          return '';
        case '1':
          return 'invoiceOutcontrol';
        case '2':
          return 'invoiceDelete';
        case '3':
          return 'invoiceRed';
        case '4':
          return 'invoiceAbnormal';
        default:
          return '';
      }
    },
    invoiceTypeFc(type) {
      switch (type) {
        case '004':
          return {
            type: '专',
            title: '增值税专用发票',
          };
        case '007':
          return {
            type: '普',
            title: '增值税普通发票',
          };
        case '14':
        case '026':
        case '028':
          return {
            type: '电',
            title: '增值税电子普通发票',
          };
        case '025':
          return {
            type: '卷',
            title: '增值税普通发票（卷式）',
          };
        default:
          return {
            type: '普',
            title: '增值税普通发票',
          };
      }
    },
    getcurrentData() {
      this.isComponent = this.judgeInvoiceType(this.invoiceData.invoiceTypeCode);
      const typeData = this.invoiceTypeFc(this.invoiceData.invoiceTypeCode);
      this.invoiceTypes = typeData.type || '';
      this.invoiceTit = typeData.title || '';
      console.log('invoiceTypes========', this.invoiceTypes);
      this.invoiceState = this.invoiceStateFc(this.invoiceData.state);
    },
  },
  watch: {
    '$route.query.time': {
      handler(n) {
        this.getcurrentData();
      },
      immediate: true,
    },
  },
};
</script>
<style  scoped>
</style>
